export type BrazeUser = {
  addAlias(alias: string, label: string): void;
  setEmail(email: string): void;
  setCustomUserAttribute(key: string, value: string | number | boolean): void;
};

export type BrazeInstance = {
  getUser(): BrazeUser | null;
  requestImmediateDataFlush(): void;
  subscribeToSdkAuthenticationFailures?(callback: (error: Error) => void): void;
};

export const getBrazeInstance = (): BrazeInstance | null => {
  if (window.braze) {
    return window.braze;
  }
  if (window.appboy) {
    return window.appboy;
  }
  return null;
};

const DEFAULT_FLUSH_TIMEOUT_MS = 200;

export const flushAndAwaitAuthResult = (
  braze: BrazeInstance,
  flushTimeoutMs: number = DEFAULT_FLUSH_TIMEOUT_MS
): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (typeof braze.subscribeToSdkAuthenticationFailures !== "function") {
      braze.requestImmediateDataFlush();
      resolve();
      return;
    }

    let settled = false;
    let timeoutId: ReturnType<typeof setTimeout>;
    const settle = (fn: () => void): void => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      fn();
    };

    braze.subscribeToSdkAuthenticationFailures((error) => {
      settle(() => reject(error));
    });

    timeoutId = setTimeout(() => {
      settle(resolve);
    }, flushTimeoutMs);

    braze.requestImmediateDataFlush();
  });
};
